import React,{useState} from 'react';
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import "./index.css";
import PropTypes from "prop-types";
import HomeCardComponent from "../../../../clipstore/user/home/card";
import SelectPrice from "../../../../clipstore/user/home/details/pricing";
import WalletBalanceBarComponent from "../../../../Wallet/BalanceBar";
import assets from "../../../../../util/assets";
import HomeContainer from "../../../../../container/content/Home";
import util from "../../../../../util/clipstore/user/home";
import {getWalletBalance} from "@practicalcodelabs/moneyblox-dev";
import {getEncryptedIdForBroadcaster} from "../../../../../util/broadcast_util";
import MoreVideo from "../../../../clipstore/user/more/video";

const checkIfLoggedIn = (setLoggedIn) => {
    util.checkLoggedIn((isLoggedIn) => {
        setLoggedIn(isLoggedIn)
    })
}

const PremiumContentModal = (props) => {

    const [isLoggedIn, setLoggedIn] = useState(false);
    const anySelection = props.prices.filter(function (price) {
        return price.isSelected
    });
    checkIfLoggedIn(setLoggedIn)

    return (
        <Modal isOpen={props.isOpen} className="premium-content-modal">
            <ModalHeader className="border-0">

            </ModalHeader>
            <ModalBody className="justify-content-center">
                <Row>
                    <Col md="6">
                        <div className="please-select-an-opt">Please select an option to play the following video</div>
                        <HomeCardComponent
                            openBroadcasterProfile={(content)=>{
                                const encryptBroadcasterId = getEncryptedIdForBroadcaster(content.broadcaster.id)

                                props.toggle("open_profile",encryptBroadcasterId);
                            }}

                            isDetailModal={true}
                            openDetail={(content) => {
                            }}
                            content={props.content}
                            key={`home-detail-card-component-${props.content.id}`}
                        />

                        <div className="premium-content-modal-description">
                            {props.content.hasOwnProperty("description") && props.content.description}
                        </div>
                        {
                            props.content.hasOwnProperty("tags") &&
                            <div className="premium-content-modal-tags">
                                Tags:
                                {
                                    props.content.tags.map((tag, index) => {
                                        return (
                                            <span className="premium-content-modal-tag" key={`premium-content-modal-tag-${index}`}>{tag.name}</span>
                                        )
                                    })
                                }
                            </div>
                        }

                        <div className="gallery-videos-container-collapse">

                            {
                                props.content.hasOwnProperty("videos") && props.content.videos.map((content, index) => {
                                    return (
                                        <MoreVideo
                                            border
                                            selectedIndex={props.selectedIndexOnGallery}
                                            playing={false}
                                            index={index}
                                            horizontal={true}
                                            key={`galleries-video-${index}`}
                                            content={content}
                                            openDetail={(content, index) => {
                                                props.setVideoPriceForSelectedGallery(props.content,index)
                                            }}
                                        />
                                    )
                                })
                            }
                        </div>
                    </Col>
                    <Col md="6" className="premium-content-modal-column2">
                        {
                            props.prices.map((price, index) => {
                                if (price.amount !== 0) {
                                    return (
                                        <SelectPrice
                                            key={`select-payment-option-${index}`}
                                            isSelected={price.isSelected}
                                            name={price.name}
                                            label={price.label}
                                            value={price.value}
                                            description={price.description}
                                            amount_formatted={price.amount_formatted}
                                            setPaymentChoice={props.setPaymentChoice}
                                        />
                                    )
                                }
                            })
                        }

                        <WalletBalanceBarComponent
                            setWalletBalance={props.setWalletBalance}
                            showMoneyBloxModal={props.showMoneyBloxModal}
                            history={props.history}
                            location={props.location}
                        />
                    </Col>
                </Row>
                <div className="divider-copy"/>
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">
                <Row className="no-margin">
                    <Col sm="6" className="my-library-title no-padding text-align-left"/>
                    <Col sm="6"
                         className="no-padding display-flex-vertical-center padding-16">
                        <Button color="outline-secondary" onClick={props.toggle} style={{width: 136}}>
                            CANCEL
                        </Button>

                        <Button color="primary" style={{width: 136}} disabled={anySelection.length === 0 || !isLoggedIn} onClick={()=>{
                            props.buy(anySelection)
                        }}>
                            {
                                props.purchase_content.isFetching
                                    ?
                                    <img
                                        src={assets.loading_white}
                                        alt={"Loading"}
                                        width={26}
                                        height={26}
                                    />
                                    :
                                    "BUY"
                            }

                        </Button>
                    </Col>
                </Row>
            </ModalFooter>
        </Modal>
    );
}

PremiumContentModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    content: PropTypes.object.isRequired,
    buy:PropTypes.func.isRequired,

    purchase_content: PropTypes.object.isRequired,
};

export default PremiumContentModal;
